import { render, staticRenderFns } from "./CheckBoxSelectPair.vue?vue&type=template&id=b4269130&scoped=true&"
import script from "./CheckBoxSelectPair.vue?vue&type=script&lang=js&"
export * from "./CheckBoxSelectPair.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxSelectPair.vue?vue&type=style&index=0&id=b4269130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4269130",
  null
  
)

export default component.exports